import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sidebar-warranty',
  templateUrl: './sidebar-warranty.component.html',
  styleUrls: ['./sidebar-warranty.component.scss']
})
export class SidebarWarrantyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
